const state = {
  isShowLoginDialog: false,
  isShowOtp: false,
  phone_number: null,
  otp: null,
  isShowProfile: false,
  isShowWallet: false,
  isReRenderComponent: 1,
  isLoadingPage: true,
  isShowMenuApp: false,
  isShowUpdateInfo: false,
  titleDialogUpdateInfo: null
};

const mutations = {
  SHOW_DIALOG: state => {
    state.isShowLoginDialog = true;
  },
  HIDE_DIALOG: state => {
    state.isShowLoginDialog = false;
  },
  SHOW_OTP: state => {
    state.isShowOtp = true;
  },
  HIDE_OTP: state => {
    state.isShowOtp = false;
  },
  SET_PHONE_NUMBER: (state, data) => {
    state.phone_number = data;
  },
  SET_OTP: (state, data) => {
    state.otp = data;
  },
  SHOW_PROFILE: (state, data) => {
    state.isShowProfile = data;
  },
  SHOW_WALLET: (state, data) => {
    state.isShowWallet = data;
  },
  RERENDER_COMPONENT: (state, data) => {
    state.isReRenderComponent += 1;
  },
  LOADING_PAGE: (state, data) => {
    state.isLoadingPage = data;
  },
  SHOW_MENU_APP: (state, data) => {
    state.isShowMenuApp = data;
  },
  SHOW_UPDATE_INFO: (state, data) => {
    state.isShowUpdateInfo = data;
  },
  SET_TITLE_DIALOG_UPDATE_INFO: (state, data) => {
    state.titleDialogUpdateInfo = data;
  }
};

const actions = {
  showLoginDialog({ commit }) {
    commit("SHOW_DIALOG");
  },
  hideLoginDialog({ commit }) {
    commit("HIDE_DIALOG");
  },
  showOtpDialog({ commit }) {
    commit("SHOW_OTP");
  },
  hideOtpDialog({ commit }) {
    commit("HIDE_OTP");
  },
  setPhoneNumber({ commit }, phone_number) {
    // console.log("SET_PHONE_NUMBER", phone_number);
    commit("SET_PHONE_NUMBER", phone_number);
  },
  setOtp({ commit }, otp) {
    console.log("SET_OTP", otp);
    commit("SET_OTP", otp);
  },
  setShowProfile({ commit }, status) {
    commit("SHOW_PROFILE", status);
  },
  setShowWallet({ commit }, status) {
    commit("SHOW_WALLET", status);
  },
  reRenderComponent({ commit }) {
    commit("RERENDER_COMPONENT");
  },
  setLoadingPage({ commit }, data) {
    commit("LOADING_PAGE", data);
  },
  setShowMenuApp({ commit }, status) {
    commit("SHOW_MENU_APP", status);
  },
  setShowUpdateInfo({ commit }, bol) {
    commit("SHOW_UPDATE_INFO", bol);
  },
  setTitleDialogUpdateInfo({ commit }, title) {
    commit("SET_TITLE_DIALOG_UPDATE_INFO", title);
  },
  async connectChat({ commit }, uid) {
    if (window.StringeeSoftChat) {
      const res = await window.StringeeSoftChat.connectWS({ id: uid });
      return res;
    }
  },
  disconnectChat({ commit }) {
    if (window.StringeeSoftChat) {
      window.StringeeSoftChat.disconnect();
    }
  }
};

export default {
  state,
  mutations,
  actions
};
